module.exports = require("jspolyfill-array.prototype.find");


//////////////////
// WEBPACK FOOTER
// external "jspolyfill-array.prototype.find"
// module id = 128
// module chunks = 0